import { FC, Suspense, useEffect, useState } from 'react';
import { ThreeDotLoader } from '../components/Fallback/ThreeDotsLoader';
import { IndividualReportWrapper } from '../components/IndividualStudentReport/IndividualReportWrapper';
import { useParams } from 'react-router-dom';
import { useQueryLoader } from 'react-relay';
import { IndividualStudentReportRoadmapOverallQuery } from '../graphQLOperations/__generated__/IndividualStudentReportRoadmapOverallQuery.graphql';
import {
  getOverallProjection,
  getStudentReportStatsAndSkillsWeekly,
  getStudentRoadmapOverall,
} from '../graphQLOperations/IndividualStudentReport';
import { IndividualStudentReportOverallQuery } from '../graphQLOperations/__generated__/IndividualStudentReportOverallQuery.graphql';
import { IndividualStudentReportStatsQuery } from '../graphQLOperations/__generated__/IndividualStudentReportStatsQuery.graphql';
import { getPresignedURLsForSkill } from '../graphQLOperations/Skills';
import { SkillsPresignedURLsQuery } from '../graphQLOperations/__generated__/SkillsPresignedURLsQuery.graphql';
import { TeacherSingleSkill } from '../components/TeacherSingleSkill/TeacherSingleSkill';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import {
  selectedIndividualStudentReportState,
  setIndividualStudentReport,
} from '../redux/reducers/individualStudentReportSlice';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { endOfWeek, startOfWeek } from 'date-fns';

interface Props {}

const today = new Date();

const IndividualReport: FC<Props> = () => {
  const { studentId } = useParams();
  const [individualStudentId, setIndividualStudentId] = useState<string | null>(
    studentId ? `StudentNode:${studentId}` : null,
  );
  const dispatch = useAppDispatch();
  const isrRedux = useAppSelector(selectedIndividualStudentReportState);
  const [selectedModalSkill, setSelectedModalSkill] = useState<{ code: string } | null>(null);
  const [queryReferenceRoadmapOverall, loadRoadmapOverall] =
    useQueryLoader<IndividualStudentReportRoadmapOverallQuery>(getStudentRoadmapOverall);
  const [queryReferenceOverallProjection, loadOverallProjection] =
    useQueryLoader<IndividualStudentReportOverallQuery>(getOverallProjection);
  const [queryReferenceWeekly, loadWeeklyStats] = useQueryLoader<IndividualStudentReportStatsQuery>(
    getStudentReportStatsAndSkillsWeekly,
  );

  const [queryRefPresignedUrl, loadPresignedUrl] = useQueryLoader<SkillsPresignedURLsQuery>(getPresignedURLsForSkill);
  useEffect(() => {
    dispatch(
      setIndividualStudentReport({
        ...isrRedux,
        dates: [startOfWeek(today, { weekStartsOn: 1 }), endOfWeek(today, { weekStartsOn: 1 })],
      }),
    );
  }, [studentId]);

  return (
    individualStudentId && (
      <>
        {queryRefPresignedUrl && (
          <Dialog
            onHide={() => setSelectedModalSkill(null)}
            visible={!!selectedModalSkill}
            footer={
              <div className="tw-flex tw-justify-end tw-w-full">
                <Button outlined className="tw-border-none" label="Close" onClick={() => setSelectedModalSkill(null)} />
              </div>
            }
          >
            <Suspense
              fallback={
                <div className="tw-w-[70vw]">
                  <ThreeDotLoader dark />
                </div>
              }
            >
              <TeacherSingleSkill
                closeModalVersion={() => setSelectedModalSkill(null)}
                skillCode={selectedModalSkill?.code}
                skillsPresignedURLsQueryReference={queryRefPresignedUrl}
              />
            </Suspense>
          </Dialog>
        )}
        <Suspense
          fallback={
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[20rem] tw-w-full">
              <ThreeDotLoader dark />
              <p className="tw-text-neutral-800 tw-font-semibold tw-mb-3 tw-text-xl tw-font-['Sora']">
                Loading student report...
              </p>
            </div>
          }
        >
          <IndividualReportWrapper
            id={individualStudentId}
            selectedModalSkill={selectedModalSkill}
            setIndividualStudentId={setIndividualStudentId}
            setSelectedModalSkill={setSelectedModalSkill}
            loadPresignedUrl={loadPresignedUrl}
            queryReferenceRoadmap={queryReferenceRoadmapOverall}
            queryReferenceProjection={queryReferenceOverallProjection}
            queryReferenceWeekly={queryReferenceWeekly}
            loadWeeklyStats={loadWeeklyStats}
            loadOverallProjection={loadOverallProjection}
            loadRoadmapOverall={loadRoadmapOverall}
          />
        </Suspense>
      </>
    )
  );
};

export default IndividualReport;
